export const MOCK_DATA_GET_RAFFLE_STATUS = {
  maximumInvites: 25, //discussion -> will this vary based on user type? if yes, move to rafUserDetails
  startDate: 1765795517,
  endDate: 1766659517,
  rafflePlayersQualified: 199999, //must
  ftu: false,
  programid: 1, // ->  (null)/1/2/3/4/5, -> "This feature will be available shortly"
  cashPerInvite: 20, //discussion -> will this vary based on user type? if not, move to rafCampaingDetails
  status: "Founder", // null(not available yet) , "Founder", "Pioneer", "Exclusive"
  referredFriends: 25, //Int
  referralUrl: "https://go.botb.com/promo?key1=thisIsTestAPI",
};

export const MOCK_MISSIONS = [
  {
    id: 38044,
    name: "FIRST FRIEND",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66511,
        name: "Make a referral",
        points_reward: 0,
        is_completed: true,
        progress: 0,
        execution_count_expected: 1,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
  {
    id: 38045,
    name: "TRIPLE THREAT",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    reward: "£10 credit",
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66512,
        name: "Make a referral",
        points_reward: 0,
        is_completed: true,
        progress: 0,
        execution_count_expected: 2,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
  {
    id: 38046,
    name: "HIGH FIVE",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    reward: "£25 credit + Raffle Entry",
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66513,
        name: "Make a referral",
        points_reward: 0,
        is_completed: true,
        progress: 0,
        execution_count_expected: 3,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
  {
    id: 38047,
    name: "PERFECT TEN",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    reward: "£50 credit",
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66514,
        name: "Make a referral",
        points_reward: 0,
        is_completed: true,
        progress: 0,
        execution_count_expected: 4,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
  {
    id: 38048,
    name: "ELITE CIRCLE",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    reward: "£75 credit",
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66515,
        name: "Make a referral",
        points_reward: 0,
        is_completed: true,
        progress: 0,
        execution_count_expected: 5,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
  {
    id: 38049,
    name: "CHAMPION",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    reward: "£100 credit",
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66516,
        name: "Make a referral",
        points_reward: 0,
        is_completed: true,
        progress: 0,
        execution_count_expected: 6,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
  {
    id: 38050,
    name: "LEGEND STATUS",
    description: "Make your first referral ",
    image: "https://d146b4m7rkvjkw.cloudfront.net/b327ee1fdaef6fc441d91d-4.png",
    is_completed: false,
    is_locked: false,
    is_requires_optin: false,
    is_opted_in: false,
    time_limit_ms: null,
    active_from_ts: null,
    active_till_ts: null,
    dt_start: null,
    reward: "£150 credit",
    progress: 0,
    type: "mission",
    only_in_custom_section: false,
    custom_data: {},
    position: 1,
    tasks: [
      {
        id: 66517,
        name: "Make a referral",
        points_reward: 0,
        is_completed: false,
        progress: 0,
        execution_count_expected: 7,
        execution_count_actual: 0,
        display_progress_as_count: true,
      },
    ],
    related_games: [],
    category_ids: [],
    ach_completed_id: null,
    requires_prize_claim: false,
    prize_claimed_date_ts: null,
    complete_date: null,
    complete_date_ts: null,
    completed_today: false,
    completed_this_week: false,
    completed_this_month: false,
    availability_status: 0,
  },
];
